import {
  Box,
  Flex,
  FlexProps,
  Icon,
  useColorModeValue,
} from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import { IconType } from 'react-icons';
import { Link as RouterLink } from 'react-router-dom';

interface INavItemProps extends FlexProps {
  icon: IconType;
  link: string;
  isSelected: boolean;
  children: ReactNode;
}

export const NavItem: React.FC<INavItemProps> = ({
  icon,
  link,
  children,
  isSelected,
  ...rest
}) => {
  const hoverBg = useColorModeValue('blue.50', 'gray.700');
  const selectedBg = useColorModeValue('blue.100', 'blue.800');
  const selectedColor = useColorModeValue('blue.700', 'blue.100');
  const hoverColor = useColorModeValue('blue.600', 'blue.200');
  const defaultColor = useColorModeValue('gray.700', 'gray.300');
  const iconSelectedColor = useColorModeValue('blue.600', 'blue.200');
  const iconHoverColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <RouterLink to={link} style={{ textDecoration: 'none' }}>
      <Box
        position="relative"
        _before={{
          content: '""',
          position: 'absolute',
          left: '0',
          top: '0',
          bottom: '0',
          width: isSelected ? '3px' : '0',
          bg: useColorModeValue('blue.500', 'blue.300'),
          borderRadius: '0 2px 2px 0',
          transition: 'width 0.2s ease',
        }}
        _hover={{
          _before: {
            width: '3px',
          },
        }}
      >
        <Flex
          align="center"
          px="4"
          py="3"
          mx="2"
          borderRadius="lg"
          cursor="pointer"
          fontWeight={isSelected ? 'semibold' : 'medium'}
          fontSize="sm"
          color={isSelected ? selectedColor : defaultColor}
          bg={isSelected ? selectedBg : 'transparent'}
          _hover={{
            bg: hoverBg,
            color: hoverColor,
            transform: 'translateX(2px)',
          }}
          transition="all 0.2s ease"
          role="group"
          position="relative"
          {...rest}
        >
          {icon && (
            <Icon
              as={icon}
              mr="3"
              fontSize="18"
              color={isSelected ? iconSelectedColor : undefined}
              _groupHover={{
                color: iconHoverColor,
                transform: 'scale(1.1)',
              }}
              transition="all 0.2s ease"
            />
          )}
          <Box flex="1">{children}</Box>
          {isSelected && (
            <Box w="2" h="2" bg="blue.400" borderRadius="full" opacity="0.8" />
          )}
        </Flex>
      </Box>
    </RouterLink>
  );
};

export default NavItem;
